module.exports = __webpack_public_path__ + "static/teemo-6acd9a898c7e7b102abafad4d425613f.webp";